export default {
  ru: {
    text: 'Мы используем куки!',
    linkText: 'Что это значит?',
    label: 'Закрыть предупреждение',
    link: '/feature/2023/12/07/obrabotka-dannyh'
  }
}
